module.exports = __webpack_public_path__ + "img/caballo.55ed1ecf.jpg";